if (!customElements.get('noshi-other-field')) {
  customElements.define(
    'noshi-other-field',
    class NoshiOtherField extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';

        const toggle = this.querySelector('[data-noshi-other-toggle]');
        const wrapper = this.querySelector('[data-noshi-other-wrapper]');
        const input = this.querySelector('[data-noshi-other-input]');

        if (!toggle || !wrapper || !input) return;

        const updateField = () => {
          const isActive = toggle.checked;

          wrapper.hidden = !isActive;
          input.disabled = !isActive;
          input.required = isActive;

          toggle.setAttribute('aria-expanded', String(isActive));
        };

        toggle.addEventListener('change', () => {
          updateField();

          if (toggle.checked) {
            input.focus();
          }
        });

        updateField();
      }
    }
  );
}